import { defineComponent } from "@vue/composition-api";
import usePromotedUsers from "@/views/PagePromotedUsers/hooks/usePromotedUsers";

export default defineComponent({
  name: "usersAllController",
  setup() {
    const { render, getFirstPage } = usePromotedUsers();
    getFirstPage();
    return render;
  },
});
